import React from 'react';

const IconUserGroup = ({ size = 28, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1395 11.7295C23.5595 11.1495 22.6192 11.1495 22.0392 11.7295C21.4592 12.3095 21.4592 13.2499 22.0392 13.8299C22.6192 14.4099 23.5595 14.4099 24.1395 13.8299C24.7195 13.2499 24.7195 12.3095 24.1395 11.7295ZM25.376 10.4911C24.1125 9.22868 22.0648 9.22902 20.8018 10.4921C19.5383 11.7555 19.5383 13.8039 20.8018 15.0673C22.0652 16.3307 24.1136 16.3307 25.377 15.0673C26.6404 13.8039 26.6404 11.7555 25.377 10.4921C25.3766 10.4918 25.3763 10.4914 25.376 10.4911Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4513 7.51652C15.3738 6.43899 13.6268 6.439 12.5493 7.51651C11.4717 8.59404 11.4717 10.3411 12.5493 11.4186C13.6268 12.4961 15.3738 12.4961 16.4513 11.4186C17.5288 10.341 17.5288 8.59403 16.4513 7.51652ZM17.6883 6.27864C15.9273 4.51814 13.0726 4.51828 11.3118 6.27908C9.55088 8.04002 9.55088 10.8951 11.3118 12.656C13.0728 14.4169 15.9278 14.4169 17.6887 12.656C19.4497 10.8951 19.4492 8.03958 17.6883 6.27864C17.6885 6.27878 17.6882 6.27849 17.6883 6.27864Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.9615 11.7295C6.38151 11.1495 5.44116 11.1495 4.86116 11.7295C4.28117 12.3095 4.28117 13.2499 4.86116 13.8299C5.44116 14.4099 6.38151 14.4099 6.9615 13.8299C7.54149 13.2499 7.5415 12.3095 6.9615 11.7295ZM8.19794 10.4911C6.93445 9.22868 4.8868 9.22902 3.62373 10.4921C2.36031 11.7555 2.36031 13.8039 3.62373 15.0673C4.88714 16.3307 6.93553 16.3307 8.19894 15.0673C9.46235 13.8039 9.46235 11.7555 8.19894 10.4921C8.1986 10.4918 8.19827 10.4914 8.19794 10.4911Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6075 17.9714C22.6075 17.4881 22.9992 17.0964 23.4825 17.0964H24.417C26.5114 17.0964 28.2087 18.7936 28.2087 20.888V22.1667C28.2087 22.65 27.8169 23.0417 27.3337 23.0417C26.8504 23.0417 26.4587 22.65 26.4587 22.1667V20.888C26.4587 19.7601 25.5449 18.8464 24.417 18.8464H23.4825C22.9992 18.8464 22.6075 18.4546 22.6075 17.9714Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58366 18.8464C3.45574 18.8464 2.54199 19.7601 2.54199 20.888V22.1667C2.54199 22.65 2.15024 23.0417 1.66699 23.0417C1.18374 23.0417 0.791992 22.65 0.791992 22.1667V20.888C0.791992 18.7936 2.48924 17.0964 4.58366 17.0964H5.51816C6.00141 17.0964 6.39316 17.4881 6.39316 17.9714C6.39316 18.4546 6.00141 18.8464 5.51816 18.8464H4.58366Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.39533 20.2989C7.39533 17.5605 9.61524 15.3405 12.3537 15.3405H16.6458C19.3842 15.3405 21.6042 17.5605 21.6042 20.2989V22.1667C21.6042 22.65 21.2124 23.0417 20.7292 23.0417C20.2459 23.0417 19.8542 22.65 19.8542 22.1667V20.2989C19.8542 18.527 18.4177 17.0905 16.6458 17.0905H12.3537C10.5817 17.0905 9.14533 18.527 9.14533 20.2989V22.1667C9.14533 22.65 8.75357 23.0417 8.27033 23.0417C7.78708 23.0417 7.39533 22.65 7.39533 22.1667V20.2989Z"
        fill={color}
      />
    </svg>
  );
};

export default IconUserGroup;
